function waitForKlaviyoForm() {
  return new Promise((resolve) => {
    const checkForForm = () => {
      const klaviyoForm = document.querySelector('[data-testid="klaviyo-form-TzGgZH"]');
      const areaOfInterestInput = document.getElementById('downshift-0-input');
      const guidanceInput = document.getElementById('downshift-1-input');
      
      if (klaviyoForm && areaOfInterestInput && guidanceInput) {
        console.log('Klaviyo form found!');
        resolve({
          form: klaviyoForm,
          areaOfInterestInput,
          guidanceInput
        });
      } else {
        console.log('Waiting for Klaviyo form to load...');
        setTimeout(checkForForm, 500);
      }
    };
    checkForForm();
  });
}

async function initKlaviyoConditionalLogic() {
  try {
    const { form, areaOfInterestInput, guidanceInput } = await waitForKlaviyoForm();
    
    // Find the guidance field row more reliably
    const formRows = form.querySelectorAll('[data-testid="form-row"]');
    console.log('Found form rows:', formRows.length);
    
    let guidanceFieldRow = null;
    
    // Look for the row containing the guidance field
    formRows.forEach((row, index) => {
      const inputInRow = row.querySelector('#downshift-1-input');
      if (inputInRow) {
        guidanceFieldRow = row;
        console.log('Found guidance field in row:', index);
      }
    });
    
    if (!guidanceFieldRow) {
      console.error('Could not find guidance field row');
      return;
    }

    function toggleGuidanceField() {
      const selectedValue = areaOfInterestInput.value.trim();
      console.log('Area of Interest value:', selectedValue);
      
      const shouldShow = selectedValue === 'Schedule a Consultation';
      console.log('Should show guidance field:', shouldShow);
      
      if (shouldShow) {
        guidanceFieldRow.style.display = 'flex';
        guidanceInput.setAttribute('aria-required', 'true');
        console.log('Showing guidance field');
      } else {
        guidanceFieldRow.style.display = 'none';
        guidanceInput.removeAttribute('aria-required');
        guidanceInput.value = '';
        console.log('Hiding guidance field');
      }
    }

    // Initially hide the guidance field
    guidanceFieldRow.style.display = 'none';
    console.log('Initially hiding guidance field');

    // Listen for input changes
    areaOfInterestInput.addEventListener('input', toggleGuidanceField);
    areaOfInterestInput.addEventListener('change', toggleGuidanceField);

    // Handle dropdown option clicks with MutationObserver
    const areaOfInterestMenu = document.getElementById('downshift-0-menu');
    if (areaOfInterestMenu) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            const options = areaOfInterestMenu.querySelectorAll('[role="option"]');
            console.log('Found dropdown options:', options.length);
            options.forEach(function(option) {
              option.addEventListener('click', function() {
                console.log('Option clicked:', option.textContent);
                setTimeout(toggleGuidanceField, 100);
              });
            });
          }
        });
      });
      
      observer.observe(areaOfInterestMenu, { childList: true, subtree: true });
      console.log('MutationObserver set up for dropdown options');
    }

    // Handle dropdown toggle button clicks
    const areaOfInterestToggle = document.getElementById('downshift-0-toggle-button');
    if (areaOfInterestToggle) {
      areaOfInterestToggle.addEventListener('click', function() {
        console.log('Dropdown toggle clicked');
        setTimeout(function() {
          const options = document.querySelectorAll('#downshift-0-menu [role="option"]');
          console.log('Options found after toggle:', options.length);
          options.forEach(function(option) {
            option.addEventListener('click', function() {
              console.log('Option clicked after toggle:', option.textContent);
              setTimeout(toggleGuidanceField, 100);
            });
          });
        }, 100);
      });
    }

    console.log('Klaviyo conditional logic initialized successfully!');
    
  } catch (error) {
    console.error('Error initializing Klaviyo conditional logic:', error);
  }
}

// Initialize when DOM is ready or immediately if already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKlaviyoConditionalLogic);
} else {
  initKlaviyoConditionalLogic();
}